"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePvs = exports.pvsData = exports.resultsDefinition = void 0;
const functions_1 = require("../functions");
const property_1 = require("@genesys/property");
// Every value CoilPro returns for this coil, under CoilPro's own names, so one vocabulary runs
// from the DLL through the schema to the translation key. Errors and warnings are comma-joined
// strings; a coil can calculate successfully and still warn, so an empty warnings cell is the
// only clean result.
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: "errors"
    },
    {
        sortNo: 20,
        propertyName: "warnings"
    },
    {
        sortNo: 30,
        propertyName: "targetreached"
    },
    {
        sortNo: 40,
        propertyName: "marginontotalpower"
    },
    {
        sortNo: 50,
        propertyName: "airpressuredropdry"
    },
    {
        sortNo: 60,
        propertyName: "airtotalheat"
    },
    {
        sortNo: 70,
        propertyName: "steamtotalheat"
    },
    {
        sortNo: 80,
        propertyName: "totalheat"
    },
    {
        sortNo: 90,
        propertyName: "temperatureout"
    },
    {
        sortNo: 100,
        propertyName: "humidityout"
    },
    {
        sortNo: 110,
        propertyName: "pressureout"
    },
    {
        sortNo: 120,
        propertyName: "flow"
    },
    {
        sortNo: 130,
        propertyName: "airvelocity"
    },
    {
        sortNo: 140,
        propertyName: "airstandardvelocity"
    },
    {
        sortNo: 150,
        propertyName: "sensibletotalcapacityratio"
    },
    {
        sortNo: 160,
        propertyName: "marginal"
    },
    {
        sortNo: 170,
        propertyName: "gaugesteampressure"
    },
    {
        sortNo: 180,
        propertyName: "steammassflow"
    },
    {
        sortNo: 190,
        propertyName: "steamvelocity"
    }
];
const pvsData = (result) => ({
    errors: result.results.errors,
    warnings: result.results.warnings,
    targetreached: String(result.targetReached),
    marginontotalpower: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.marginOnTotalPower)),
    airpressuredropdry: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airPressureDropDry)),
    airtotalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airTotalHeat)),
    steamtotalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.steamTotalHeat)),
    totalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.totalHeat)),
    temperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.temperatureOut)),
    humidityout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.humidityOut)),
    pressureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.pressureOut)),
    flow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.flow)),
    airvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airVelocity)),
    airstandardvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airStandardVelocity)),
    sensibletotalcapacityratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.sensibleTotalCapacityRatio)),
    marginal: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.marginal)),
    gaugesteampressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.gaugeSteamPressure)),
    steammassflow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.steamMassFlow)),
    steamvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.steamVelocity)),
});
exports.pvsData = pvsData;
const makePvs = (result) => (0, functions_1.collectResults)((0, exports.pvsData)(result));
exports.makePvs = makePvs;
//# sourceMappingURL=result-definition.js.map